export default __webpack_public_path__ + "static/configuration-management-c0f8eb5cfcb1dbc945f6098727791c9d.png";